import "./sidebar.scss";
import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import HomeIcon from "@mui/icons-material/Home";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SettingsIcon from "@mui/icons-material/Settings";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import FastfoodIcon from "@mui/icons-material/Fastfood";

const Sidebar = () => {
  const [openPower, setOpenPower] = useState(false);

  const [openMobile, setOpenMobile] = useState(false);
  const handleToggleMobileMenu = () => {
    setOpenMobile(!openMobile);
  };

  const navigate = useNavigate();
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true,
  });

  const { user, loading, error, dispatch } = useContext(AuthContext);

  const handleLogout = async (e) => {
    e.preventDefault();
    if (user) {
      const res = await axiosInstance.put("/auth/logout");
      if (res.data) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
        setOpenPower(false);
      } else {
        dispatch({
          type: "LOGIN_FAILURE",
          payload: { message: "Something went wrong" },
        });
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div className="sidebarMobile">
        <button
          className={`mobile-menu-toggle ${openMobile ? "open" : ""}`}
          onClick={handleToggleMobileMenu}
        >
          ☰
        </button>
        {openMobile && (
          <div className={`mobile-menu ${openMobile ? "open" : ""}`}>
            <ul>
              <li>
                <Link to="/" onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">HOME</p>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/menu" onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">MENU</p>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/alergeny" onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">ALERGENY</p>
                  </div>
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">POLITYKA PRYWATNOŚCI</p>
                  </div>
                </Link>
              </li>
              <li>
                <a href="tel:+48515682850" onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">ZADZWOŃ</p>
                  </div>
                </a>
              </li>
              <li>
                <Link to={`/settings/${user?._id}`} onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title">KONTO</p>
                  </div>
                </Link>
              </li>
              <li>
                <Link to={`/login`} onClick={handleToggleMobileMenu}>
                  <div className="item">
                    <p className="title" onClick={handleLogout}>{user ? "WYLOGUJ" : "ZALOGUJ"}</p>
                  </div>
                </Link>
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="sidebar">
        <div className="top">
          <ul>
            <Link to="/" style={{ textDecoration: "none" }}>
              <div className="item">
                <li>
                  <HomeIcon className="icon" />
                </li>
                <p className="title">HOME</p>
              </div>
            </Link>
            <Link to="/menu" style={{ textDecoration: "none" }}>
              <div className="item">
                <li>
                  <FastfoodIcon className="icon" />
                </li>
                <p className="title">MENU</p>
              </div>
            </Link>
            <a href="tel:+48515682850" style={{ textDecoration: "none" }}>
              <div className="item">
                <li>
                  <LocalPhoneIcon className="icon" />
                </li>
                <p className="title">ZADZWOŃ</p>
              </div>
            </a>
          </ul>
        </div>
        <div className="bottom">
          <ul>
            <Link
              to={`/settings/${user?._id}`}
              style={{ textDecoration: "none" }}
            >
              <div className="item">
                <li>
                  <SettingsIcon className="icon" />
                </li>
                <p className="title">KONTO</p>
              </div>
            </Link>
            <div className="item" onClick={() => setOpenPower(!openPower)}>
              <li>
                <PowerSettingsNewIcon className="icon" />
              </li>
            </div>
          </ul>
        </div>
        {openPower && (
          <div className="power">
            <span onClick={handleLogout}>{user ? "Wyloguj" : "Zaloguj"}</span>
          </div>
        )}
      </div>
    </>
  );
};

export default Sidebar;
